import { Pipe, PipeTransform } from '@angular/core';
import { PaypalPromoCodeModal } from '../../SuperAdmin/models/PaypalPromocode.model';

@Pipe({
  name: 'saPaypalPromocodeFilter'
})
export class SaPaypalPromocodeFilterPipe implements PipeTransform {

  transform(LogData: PaypalPromoCodeModal[], searchTermLogPromo: string): PaypalPromoCodeModal[] {
    if (!LogData || !searchTermLogPromo) { return LogData; }

    // LogData.forEach(element => {
    //   if(element.LicenseNo==null ){
    //     element.LicenseNo="";
    //   }
    //   if(element.Types==null ){
    //     element.Types="";
    //   }
    // });
   

    return LogData.filter(ad =>
     
    
      ad.promoName.toLowerCase().indexOf(searchTermLogPromo.toLowerCase().trim()) !== -1
      ||
      ad.promoExpiryDate.toLowerCase().indexOf(searchTermLogPromo.toLowerCase().trim())!==-1
      
      

      
    );
  }

}
